
import { Component, Vue } from "vue-property-decorator";

@Component({
  name: "TableHeader",
})
export default class extends Vue {
  private deleterowdata() {
    console.log("|FUNC|deleterowdata");
    this.$emit("deletedatahistory"); //触发$emit绑定的watchChild方法
  }
}
